module.exports = __webpack_public_path__ + "carousel_04_img_04.png?2c94914ee85d5c5109aee9911b13e236";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/carousel_04_img_04.png
// module id = 159
// module chunks = 0